import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";
import MainHeader from "../components/MainHeader";
import { createFileDownloadUrl, elsevierStyleSheetJSfileImport } from "../library/utils";
import { backendBookartUrl } from "../library/constants";
import axios from "axios";
import EmptyCart from "../components/EmptyCart";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Checkout = () => {
  const [progress, setProgress] = useState({
    address: true,
    preview: false,
    confirmation: false,
  });
  const [billingAddress, setBillingAddress] = useState({
    address: "",
    itemToShowed: 1,
    expanded: false,
  });
  const [shippingAddress, setShippingAddress] = useState({
    address: "",
    itemToShowed: 2,
    expanded: false,
  });
  const [billto_address, setBilltoAddress] = useState([]);
  const [shipto_address, setShiptoAddress] = useState([]);
  const [cartProducts, setCartProducts] = useState([]);
  const [sameAddress, setSameAddress] = useState(false);
  const [instantOrder, setInstantOrder] = useState({
    attachment: null,
    fileDownloadUrl: null,
    to: null,
    cc: [],
    subject: "",
    comments: "",
  });
  const [acceptTermCondition, setAcceptTermCondition] = useState(false);
  const [order_number, setOrderNumber] = useState(null);
  const [cartUpdated, setCartUpdated] = useState(false);
  const [auth, setAuth] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleBillingAddress = (event) => {
    const value = event.target.value;
    setBillingAddress((prev) => ({ ...prev, address: value }));
  };

  const handleShippingAddress = (event) => {
    const value = event.target.value;
    const event_target = event.target;
    let arr = Array.from(document.getElementsByName(event.target.name));
    arr.forEach((el) => {
      el.checked = el.id === event_target.id;
    });
    setShippingAddress((prev) => ({ ...prev, address: value }));
  };

  const showMore = (address) => {
    if (address.toLowerCase() === "billing") {
      setBillingAddress((prev) => ({
        ...prev,
        expanded: true,
        itemToShowed: billto_address.length,
      }));
    } else if (address.toLowerCase() === "shipping") {
      setShippingAddress((prev) => ({
        ...prev,
        expanded: true,
        itemToShowed: shipto_address.length,
      }));
    }
  };

  const handleSameAddress = () => {
    setSameAddress((prev) => !prev);
    setShippingAddress({
      address: "",
      itemToShowed: 2,
      expanded: false,
    });
  };

  const handleConfirmAddress = (event) => {
    event.preventDefault();
    setProgress((prev) => ({
      ...prev,
      address: false,
      preview: true,
      confirmation: false,
    }));
  };

  const handleConfirmOrder = (event) => {
    event.preventDefault();
    const emailId = window.sessionStorage.getItem("emailId");
    const token = window.sessionStorage.getItem("JWTtoken");

    if (instantOrder.attachment != null) {
      const formData = new FormData();
      formData.append("useremailaddress", emailId);
      formData.append("shiptoaddress", sameAddress ? billingAddress.address : shippingAddress.address);
      formData.append("billtoaddress", billingAddress.address);
      formData.append("comments", instantOrder.comments);
      formData.append("files", instantOrder.attachment);
      formData.append("ToAddress", instantOrder.to);
      formData.append("CCAddress", instantOrder.cc);
      formData.append("subject", instantOrder.subject);

      axios.post(`${backendBookartUrl}/insert_bulk_orders?=`, formData, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.data.is_order_place) {
            setProgress({
              address: false,
              preview: false,
              confirmation: true,
            });
            setInstantOrder({
              attachment: null,
              fileDownloadUrl: null,
              to: null,
              cc: [],
              subject: "",
              comments: "",
            });
            setOrderNumber(response.data.order_number);
          } else {
            alert("There was an error while placing your order. Redirecting to All Books.");
            navigate("/list");
          }
        })
        .catch((error) => {
          console.log("Error placing order:", error);
        });
    } else {
      const cart_id = cartProducts.map((element) => element.cart_id);
      const discount_total = cartProducts.reduce(
        (discount, element) => discount + element.discount_price * element.quantity,
        0
      );
      const cart_total = cartProducts.reduce(
        (sum, element) => sum + element.total_price * element.quantity,
        0
      );
      const grant_total = cartProducts.reduce(
        (sum, element) => sum + element.subtotal,
        0
      );

      const data = JSON.stringify({
        cart_id: cart_id,
        billtoaddress: billingAddress.address,
        shiptoaddress: sameAddress ? billingAddress.address : shippingAddress.address,
        discount_total: discount_total,
        cart_total: cart_total,
        grant_total: grant_total,
        comments: instantOrder.comments,
        is_bulk: false,
      });

      axios.post(`${backendBookartUrl}/insert_order_details?=`, data, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.data.is_order_place) {
            setProgress({
              address: false,
              preview: false,
              confirmation: true,
            });
            setOrderNumber(response.data.order_number);
            setCartUpdated(true);
            //setTimeout(() => setCartUpdated(false), 1000); // Reset cartUpdated after 1 second
          } else {
            alert("There was an error while placing your order. Redirecting to All Books.");
            navigate("/list");
          }
        })
        .catch((error) => {
          console.log("Error inserting order details:", error);
        });
    }
  };

  const handleChangeComments = (event) => {
    event.preventDefault();
    const value = event.target.value;
    setInstantOrder((prev) => ({ ...prev, comments: value }));
  };

  const handleCheckBox = () => {
    setAcceptTermCondition((prev) => !prev);
  };

  const setupInstantOrder = () => {
    const propState = location.state;
    if (propState && propState.instantOrder) {
      setInstantOrder((prev) => ({
        ...prev,
        to: propState.instantOrder.to,
        cc: propState.instantOrder.cc,
        subject: propState.instantOrder.subject,
        attachment: propState.instantOrder.attachment,
        fileDownloadUrl: createFileDownloadUrl(propState.instantOrder.attachment),
      }));
    }
  };

  useEffect(() => {
    authUser(); // Authenticate User
    elsevierStyleSheetJSfileImport();
    fetchAddress();
    fetchCartDetails();
    setupInstantOrder();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAddress = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    axios.post(`${backendBookartUrl}/view_address_details?=`, {}, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        const address = response.data.address;
        setBilltoAddress(address.billto_address);
        setShiptoAddress(address.shipto_address);
      })
      .catch((error) => {
        console.log("Error fetching address details:", error);
      });
  };

  const fetchCartDetails = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    axios.post(`${backendBookartUrl}/view_cart_details`, {}, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        setCartProducts(response.data.cart_details);
      })
      .catch((error) => {
        console.log("Error fetching cart details:", error);
      });
  };


  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    if (token === null) {
      navigate("/");
    } else {
      setAuth(true);
    }
  };

  // Conditional rendering based on authentication status
  if (!auth) {
    return <div></div>; // Optionally, you can show a loading indicator here
  }
  else {
    return (
      <React.Fragment>
        <MainHeader cartUpdated={cartUpdated} fetchCartAfterModifying={fetchCartDetails} />

        <section className="container padding-bottom-10 min-height60" >
          <Link to="/shoppingCart" className="es-link colored font-16">
            <svg viewBox="0 0 54 128" height="16" width="11">
              <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
            </svg>
            &nbsp;Back to cart
          </Link>
          <h2 className="margin-top-10p">Checkout</h2>
          <br />
          <div className="checkout-progress">
            <ol className="progress-tracker">
              <li
                className={
                  progress.address
                    ? "progress-step is-active"
                    : `progress-step ${progress.preview ? "after-clear" : ""
                    } ${progress.confirmation ? "after-clear" : ""
                    }`
                }
              >
                <span className="progress-step__marker">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112 128" height="24" width="21">
                    <path d="M101 104H11V50h32V40H13.67L26.9 22H51v28h10V22h24.1l13.23 18H69v10h32v54zM90.16 12H21.84L1 40.36V114h110V40.36L90.16 12" />
                  </svg>
                </span>
                <span className="progress-step__text">Address</span>
              </li>
              <li className={progress.preview ? "progress-step is-active" : `progress-step ${progress.confirmation ? "after-clear" : ""}`}>
                <span className="progress-step__marker">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 128" height="24" width="22">
                    <path d="M23 70h18v10H23V70zm73 22H18c-3.86 0-7-3.14-7-7V58h92v27c0 3.86-3.14 7-7 7zM18 34h78c3.86 0 7 3.14 7 7v7H11v-7c0-3.86 3.14-7 7-7zm95 7c0-9.39-7.61-17-17-17H18C8.61 24 1 31.61 1 41v44c0 9.39 7.61 17 17 17h78c9.39 0 17-7.61 17-17V41" />
                  </svg>
                </span>
                <span className="progress-step__text">Preview</span>
              </li>
              <li className={progress.confirmation ? "progress-step is-active" : "progress-step"}>
                <span className="progress-step__marker">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 128" height="24" width="17">
                    <path d="M0 58.08l7.86-6.18 29.18 37.14 42.24-67.7 8.48 5.3-49.78 79.8z" />
                  </svg>
                </span>
                <span className="progress-step__text">Confirmation</span>
              </li>
            </ol>
          </div>
          {progress.address ? (
            <div className="container min-height60">
              <div className="row address-row">
                <div className="col-md-8 address-details">
                  <div className="margin-bottom-30">
                    <h3>Billing address</h3>
                    {billto_address.slice(0, billingAddress.itemToShowed).map((element, key) => (
                      <label className="es-check small margin-bottom-20 margin-left-20" key={"billing-" + key}>
                        <input
                          className="es-check-input"
                          type="checkbox"
                          checked={billingAddress.address === element}
                          onChange={handleBillingAddress}
                          value={element}
                        />
                        <span className="font-16">
                          Billing address {key + 1}
                          <br />
                          <div className="margin-left-25v">{element}</div>
                        </span>
                      </label>
                    ))}
                    {billingAddress.expanded ? null : (
                      <button
                        className="es-link colored font-16"
                        onClick={() => showMore("billing")}
                      >
                        <span>View all</span>
                      </button>
                    )}
                  </div>
                  <div className="margin-bottom-30">
                    <label className="es-check small">
                      <input
                        className="es-check-input"
                        type="checkbox"
                        checked={sameAddress}
                        onChange={handleSameAddress}
                      />
                      <span className="font-16">
                        Billing and the shipping address are the same
                      </span>
                    </label>
                  </div>
                  {!sameAddress ? (
                    <div className="margin-bottom-30">
                      <h3>Shipping address</h3>
                      {shipto_address.slice(0, shippingAddress.itemToShowed).map((element, key) => (
                        <label className="es-check small margin-bottom-20 margin-left-20" key={"shipping-" + key}>
                          <input
                            className="es-check-input"
                            id={element}
                            name="checkbox-shipping_address"
                            type="checkbox"
                            onChange={handleShippingAddress}
                            value={element}
                          />
                          <span className="font-16">
                            Shipping address {key + 1}
                            <br />
                            <div className="margin-left-25v">{element}</div>
                          </span>
                        </label>
                      ))}
                      {shippingAddress.expanded ? null : (
                        <button
                          className="es-link colored font-16"
                          onClick={() => showMore("shipping")}
                        >
                          <span>View all</span>
                        </button>
                      )}
                    </div>
                  ) : null}
                  <strong className="font-16">
                    To add or update Address, Please contact your regional Account Manager or -
                    {/* <a
                      href="mailto:IndiaHSBooks@elsevier.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-auth="NotApplicable"
                      data-linkindex="5"
                    >
                      {" Health Science Team"}
                    </a> */}
                    <div
                      className="email_link pointer"
                      onClick={() => {
                        // Change the screen to "mail"
                        navigate("/support", { state: { emailus: "mail" } });
                      }}
                    >
                      Health Science Team
                    </div>
                  </strong>
                </div>
                <div className="col-md-4 confirm-address">
                  <div className="border order-summary">
                    {instantOrder.attachment != null ? (
                      <div>
                        <h5>Instant Order</h5>
                        <hr />
                        <label className="font-16">Processing the content of the file</label>
                        <br />
                        <a
                          className="es-link aligned font-14"
                          download={instantOrder.attachment.name}
                          href={instantOrder.fileDownloadUrl}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 98 128"
                            height="18"
                            width="19"
                          >
                            <path
                              fill="#0c7dbb"
                              d="M28.92 120c-6.9 0-13.49-2.8-18.63-7.93-11.43-11.39-10.6-28.12 2.01-40.69 0 0 15.51-15.49 24.18-24.14 3.71-3.69 8.51-5.58 13.5-5.36 4.6.22 8.98 2.19 12.35 5.54 3.36 3.35 5.33 7.72 5.54 12.3.22 4.96-1.7 9.73-5.41 13.42L39.65 95.88l-7.13-7.11 22.81-22.74c1.71-1.7 2.55-3.72 2.46-5.87-.09-2.03-1.04-4.08-2.59-5.63-1.57-1.56-3.64-2.51-5.69-2.61-2.16-.12-4.2.74-5.9 2.43-8.66 8.64-24.17 24.13-24.17 24.13-8.69 8.66-9.48-19.05-2.02 26.48 3.39 3.39 7.54 5.13 11.95 4.98 4.92-.14 9.92-2.61 14.46-7.14l34.45-34.32c5.8-5.79 9.01-12.42 9.29-19.18.27-6.82-2.54-13.36-8.13-18.93-5.66-5.65-12.19-8.55-18.84-8.31-6.69.21-13.4 3.48-19.4 9.47L8.13 64.47 1 57.37l33.07-32.95c7.84-7.82 16.91-12.11 26.22-12.4 9.49-.31 18.6 3.59 26.28 11.24 7.64 7.6 11.46 16.75 11.07 26.44-.37 9.33-4.6 18.28-12.24 25.89l-34.44 34.32c-6.39 6.37-13.75 9.86-21.3 10.08-.25 0-.5.02-.74.02"
                            />
                          </svg>
                          &nbsp;
                          <strong className="file-color">
                            {instantOrder.attachment.name}
                          </strong>
                        </a>
                        <hr />
                        <div className="text-center">
                          <button
                            className="es-button primary medium text-center"
                            type="button"
                            disabled={
                              (billingAddress.address === "" ||
                                shippingAddress.address === "") &&
                              (!sameAddress || billingAddress.address === "")
                            }
                            onClick={handleConfirmAddress}
                          >
                            <span>Confirm Address</span>
                            <svg
                              focusable="false"
                              height="24"
                              viewBox="0 0 54 128"
                              width="11"
                            >
                              <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div>
                        {cartProducts.length !== 0 ? (
                          <div>
                            <table className="table table-borderless">
                              <tbody className="font-16">
                                <tr>
                                  <td>
                                    Cart total ({cartProducts.length} items)
                                  </td>
                                  <td>
                                    <strong>
                                      ₹&nbsp;
                                      {cartProducts.reduce(
                                        (sum, element) =>
                                          sum + element.total_price * element.quantity,
                                        0
                                      )}
                                    </strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Discount total (
                                    {cartProducts.length} items)
                                  </td>
                                  <td>
                                    <strong>
                                      ₹&nbsp;
                                      {cartProducts.reduce(
                                        (discount, element) =>
                                          discount + element.discount_price * element.quantity,
                                        0
                                      )}
                                    </strong>
                                  </td>
                                </tr>
                                <tr className="order-summary-grand-total">
                                  <td>
                                    Grand total (
                                    {cartProducts.length} items)
                                  </td>
                                  <td>
                                    <strong>
                                      ₹&nbsp;
                                      {cartProducts.reduce(
                                        (sum, element) =>
                                          sum + element.subtotal,
                                        0
                                      )}
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <button
                              className="es-button primary medium text-center w-100"
                              type="button"
                              disabled={
                                (billingAddress.address === "" ||
                                  shippingAddress.address === "") &&
                                (!sameAddress || billingAddress.address === "")
                              }
                              onClick={handleConfirmAddress}
                            >
                              <span>Confirm Address</span>
                              <svg
                                focusable="false"
                                height="24"
                                viewBox="0 0 54 128"
                                width="11"
                              >
                                <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
                              </svg>
                            </button>
                          </div>
                        ) : (
                          <EmptyCart />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (<></>)}
          {progress.preview ? (
            <div className="container min-height60">
              <div className="preview-content">
                <h3>Preview and Payment</h3>
                <div className="es-card">
                  <div className="es-card-body-grey ">
                    {instantOrder.attachment != null ? (
                      <div>
                        <label className="font-18">Attachment</label> <br />
                        <a
                          className="es-link aligned font-14"
                          download={instantOrder.attachment.name}
                          href={instantOrder.fileDownloadUrl}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 98 128"
                            height="18"
                            width="19"
                          >
                            <path
                              fill="#0c7dbb"
                              d="M28.92 120c-6.9 0-13.49-2.8-18.63-7.93-11.43-11.39-10.6-28.12 2.01-40.69 0 0 15.51-15.49 24.18-24.14 3.71-3.69 8.51-5.58 13.5-5.36 4.6.22 8.98 2.19 12.35 5.54 3.36 3.35 5.33 7.72 5.54 12.3.22 4.96-1.7 9.73-5.41 13.42L39.65 95.88l-7.13-7.11 22.81-22.74c1.71-1.7 2.55-3.72 2.46-5.87-.09-2.03-1.04-4.08-2.59-5.63-1.57-1.56-3.64-2.51-5.69-2.61-2.16-.12-4.2.74-5.9 2.43-8.66 8.64-24.17 24.13-24.17 24.13-8.69 8.66-9.48-19.05-2.02 26.48 3.39 3.39 7.54 5.13 11.95 4.98 4.92-.14 9.92-2.61 14.46-7.14l34.45-34.32c5.8-5.79 9.01-12.42 9.29-19.18.27-6.82-2.54-13.36-8.13-18.93-5.66-5.65-12.19-8.55-18.84-8.31-6.69.21-13.4 3.48-19.4 9.47L8.13 64.47 1 57.37l33.07-32.95c7.84-7.82 16.91-12.11 26.22-12.4 9.49-.31 18.6 3.59 26.28 11.24 7.64 7.6 11.46 16.75 11.07 26.44-.37 9.33-4.6 18.28-12.24 25.89l-34.44 34.32c-6.39 6.37-13.75 9.86-21.3 10.08-.25 0-.5.02-.74.02"
                            />
                          </svg>
                          &nbsp;
                          <strong className="file-color">
                            {instantOrder.attachment.name}
                          </strong>
                        </a>
                        <br />
                        <div className="row">
                          <div className="col-md-6">
                            <label className="font-18">Billing address</label>
                            <br />
                            <label className="font-16">
                              {billingAddress.address}
                            </label>
                          </div>
                          <div className="col-md-6">
                            <label className="font-18">Shipping address</label>
                            <br />
                            {sameAddress ? (
                              <label className="font-16">
                                {billingAddress.address}
                              </label>
                            ) : (
                              <label className="font-16">
                                {shippingAddress.address}
                              </label>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <label className="font-18">Items in your cart</label>{" "}
                        <br />
                        <div id="cart-details">
                          <ul className="es-list product-preview">
                            {cartProducts.map((element) => {
                              return (
                                <li
                                  key={element.product_id}
                                  className="font-14 products-in-preview"
                                >
                                  <strong>Title:&nbsp;</strong>
                                  {element.title} <br />
                                  <strong>ISBN:&nbsp;</strong>
                                  {element.product_id}
                                  <br />
                                  <strong>Qty:&nbsp;</strong>
                                  {element.quantity}
                                </li>
                              );
                            })}
                          </ul>
                          <div className="row">
                            <div className="col-md-6">
                              <label className="font-18">Billing address</label>
                              <br />
                              <label className="font-16">
                                {billingAddress.address}
                              </label>
                            </div>
                            <div className="col-md-6">
                              <label className="font-18">Shipping address</label>
                              <br />
                              {sameAddress ? (
                                <label className="font-16">
                                  {billingAddress.address}
                                </label>
                              ) : (
                                <label className="font-16">
                                  {shippingAddress.address}
                                </label>
                              )}
                            </div>
                          </div>
                        </div>
                        <br />
                        <div>
                          <label className="font-18">Order Summary</label>
                          <table className="table margin-0">
                            <tbody className="font-16">
                              <tr>
                                <td className="preview-table-left-content">
                                  Cart total ({cartProducts.length} items)
                                </td>
                                <td className="preview-table-right-content">
                                  ₹&nbsp;
                                  {cartProducts.reduce(
                                    (sum, element) =>
                                      sum +
                                      element.total_price * element.quantity,
                                    0
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td className="preview-table-left-content">
                                  Discount total (
                                  {cartProducts.length} items)
                                </td>
                                <td className="preview-table-right-content">
                                  ₹&nbsp;
                                  {cartProducts.reduce(
                                    (discount, element) =>
                                      discount +
                                      element.discount_price * element.quantity,
                                    0
                                  )}
                                </td>
                              </tr>

                            </tbody>
                          </table>
                          <hr className="margin-0 line-style" />
                          <table className="table margin-0">
                            <tbody className="font-16">
                              <tr>
                                <td>
                                  Grand total ({cartProducts.length} items)
                                </td>
                                <td>
                                  <span className="right-float">
                                    <strong>
                                      ₹&nbsp;
                                      {cartProducts.reduce(
                                        (sum, element) => sum + element.subtotal,
                                        0
                                      )}
                                    </strong>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <br />
                <div className="es-card">
                  <div className="es-card-body-grey">
                    <label className="font-18">Payment</label>
                    <br />
                    <label className="font-14">
                      Payment to be made as per your credit terms
                    </label>
                  </div>
                </div>
                <div className="formGroup">
                  <div className="es-input-text">
                    <input
                      id="comments"
                      name="comments"
                      value={instantOrder.comments}
                      placeholder="&nbsp;"
                      onChange={handleChangeComments}
                    />
                    <label htmlFor="comments">
                      Add message for the admin (Optional)
                    </label>
                  </div>
                </div>
                <div className="formGroup">
                  <label className="es-check small margin-top-bottom-3v">
                    <input
                      className="es-check-input"
                      name="signedIn"
                      checked={acceptTermCondition}
                      type="checkbox"
                      onChange={handleCheckBox}
                    />
                    <span>I hereby confirm my order</span>
                  </label>
                </div>
                <button
                  className="es-button primary medium text-center button-30"
                  type="button"
                  disabled={!acceptTermCondition}
                  onClick={handleConfirmOrder}
                >
                  <span>Confirm order</span>
                  <svg
                    focusable="false"
                    height="24"
                    viewBox="0 0 54 128"
                    width="11"
                  >
                    <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
                  </svg>
                </button>
              </div>
            </div>
          ) : (
            <div></div>
          )}
          {progress.confirmation ? (
            <div className="container min-height60">
              <div className="margin-left-10">
                <div className="margin-bottom-30">
                  <h2 className="margin-bottom-20">
                    Thank you for placing your order request!
                  </h2>
                  Your order reference number is{" "}
                  <strong>{order_number}</strong>
                </div>
                <div className="margin-bottom-30 font-16">
                  <strong className="font-16">
                    Note: A copy of your order request along with a unique
                    reference number will be sent to your registered email
                    address - {window.sessionStorage.getItem("emailId")}. If you
                    have any changes, please contact your regional Account
                    Manager or
                  </strong>{" "}
                  <div
                      className="email_link pointer"
                      onClick={() => {
                        // Change the screen to "mail"
                        navigate("/support", { state: { emailus: "mail" } });
                      }}
                    >
                      Health Science Team
                    </div>
                </div>
                <Link to="/list" className="es-button primary medium text-center">
                  <span>Continue Shopping</span>
                </Link>
              </div>
            </div>
          ) : null}
        </section>
        <Footer />
      </React.Fragment>
    )
  }
};
export default Checkout;
